<div class="grid sm:grid-cols-1 md:grid-rows-login md:grid-cols-2 h-screen">
    <app-header class="md:col-span-2"></app-header>
    <div class="sm:row-start-2 sm:row-end-3 bg-gradient-b-gray-white b h-full p-8">
        <router-outlet></router-outlet>
    </div>
    <div class="sm:row-start-3 sm:row-end-4 md:row-start-2 md:row-end-3">
        <app-splash id="public-splash-img-div"></app-splash>
    </div>
    <div class="sm:row-start-4 sm:row-end-5 md:row-start-3 md:row-end-4 md:col-span-2">
        <app-footer class="w-full "></app-footer>
    </div>
</div>
